import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        addressContainer: {
            flexDirection: 'column',
            gap: remCalc(4),
        },
        formTitle: {
            textStyle: 'body-large',
            paddingBottom: remCalc(16),
            borderBottomColor: 'border.light',
            borderBottomWidth: remCalc(1),
        },
        formContainer: {
            paddingBottom: remCalc(16),
        },
        clearFieldsContainer: {
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: remCalc(16),
            marginTop: remCalc(16),
        },
        addressFieldsContainer: {
            marginLeft: remCalc(2),
            pb: remCalc(24),
        },
        privacyNoteText: {
            textStyle: 'body-small',
            color: 'text.secondary',
            fontWeight: 'medium',
            pb: remCalc(24),
        },
        accuracyNoteText: {
            textStyle: 'body-small',
            bgColor: 'background.light',
            borderColor: 'border.light',
            borderWidth: remCalc(1),
            borderStyle: 'solid',
            padding: remCalc(26),
            alignItems: 'center',
            marginBottom: remCalc(16),
            gap: remCalc(16),
        },
    },
    variants: {
        'account-address': {
            formTitle: {
                textStyle: {base: 'head-large', md: 'head-large', lg: 'head-xlarge'},
                paddingTop: {base: remCalc(16), lg: remCalc(24)},
                paddingBottom: remCalc(24),
                fontWeight: 'medium',
                borderBottom: 'small',
            },
            formContainer: {
                paddingTop: 0,
            },
            clearFieldsContainer: {
                marginTop: remCalc(24),
            },
        },
    },
}
